var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChanneltalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 151 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 0C33.5774 0 0 33.5774 0 75C0 96.6343 9.17426 116.118 23.8309 129.806C10.5679 149.677 -2.63044 176.572 48.6402 145.219C56.8453 148.302 65.7242 150 75.0092 150C116.432 150 150.009 116.423 150.009 75C150.009 33.5774 116.423 0 75 0Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2619 85.1253C44.4612 85.1253 48.6761 80.9104 48.6761 75.7111C48.6761 70.5118 44.4612 66.2969 39.2619 66.2969C34.0625 66.2969 29.8477 70.5118 29.8477 75.7111C29.8477 80.9104 34.0625 85.1253 39.2619 85.1253Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0607 85.1253C81.26 85.1253 85.4749 80.9104 85.4749 75.7111C85.4749 70.5118 81.26 66.2969 76.0607 66.2969C70.8614 66.2969 66.6465 70.5118 66.6465 75.7111C66.6465 80.9104 70.8614 85.1253 76.0607 85.1253Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.868 85.1253C118.068 85.1253 122.283 80.9104 122.283 75.7111C122.283 70.5118 118.068 66.2969 112.868 66.2969C107.669 66.2969 103.454 70.5118 103.454 75.7111C103.454 80.9104 107.669 85.1253 112.868 85.1253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChanneltalk);
export default __webpack_public_path__ + "static/media/icon-channeltalk.abb838fdeea3fe9305dbb2e05c54e248.svg";
export { ForwardRef as ReactComponent };